import { Button, Card, Col, Form, Row, Typography, Select } from 'antd';
import Input from '../../ui/Input';
import ActionButtonsBar from '../../ui/ActionButtonsBar';
import { SyntheticEvent, useState } from 'react';
const { Title } = Typography
const Option = Select.Option
const FormItem = Form.Item

const ODSForm = (props: { 
    record: { name: string } | null, 
    handleSubmit: (data: object[]) => void,
    setCurrentRecord: (e: any) => void
}) => {
    const { record, handleSubmit } = props
    const [form] = Form.useForm()
    const [mode, setMode] = useState<'view' | 'edit'>(record ? 'view' : 'edit')
    const [disabledStatus, setDisabledStatus] = useState(false)
    const options: string[] = ['Yes', ' No']
    const enterEditMode = () => {
        setMode('edit')
        window.editFunction()
    }
    const back = () => {
        props.setCurrentRecord(null)
    }
    const validateFieldsError = (changedValues:any,allValues:any) => {
        form.validateFields().then(() => {
            setDisabledStatus(false)
        }).catch(() => {
            const detailErrNum = form.getFieldsError()?.filter(({ errors }: { errors: any }) => errors.length).length;
            if (detailErrNum === 0) {
                setDisabledStatus(false)
            } else {
                setDisabledStatus(true)
            }
        })
    }
    const enterViewMode = () => {
        setMode('view')
        window.cancelEdition()
    }

    const handleClickSave = async (e: SyntheticEvent) => {
        e.preventDefault()
        form.validateFields()
            .then(async (values) => {
                try {
                    await handleSubmit([{ ...record as object, ...values }])
                } finally {
                    enterViewMode()
                }
            });
    }

    const handleClickCancel = () => {
        form.resetFields()
        enterViewMode()
    }

    return (
      <Card style={{ margin: '0 15px 15px' }}>
        <Row justify='end'>
          {mode === 'view' && (
            <>
              <div style={{ margin: '0 10px 0 0' }}>
                <Button className='db-edit-btn' onClick={back}>
                  Back
                </Button>
              </div>
              <div>
                <Button className='db-edit-btn' onClick={enterEditMode}>
                  Edit
                </Button>
              </div>
            </>
          )}
        </Row>
        <Row justify='space-between' style={{ marginBottom: 15 }}>
          <Title level={5}>{record?.name}</Title>
        </Row>

        <Form
          form={form}
          layout='vertical'
          initialValues={record as object}
          onValuesChange={validateFieldsError}>
          <div
            style={{ paddingLeft: 8 }}
            className={mode === 'view' ? 'is-disabled-fields' : ''}>
            <Row gutter={24}>
              <Col span='6'>
                <Form.Item
                  label='Chain'
                  name='chain'
                  rules={[
                    {
                      type: 'string',
                      max: 2,
                      message: 'You have reached the max character length of 2',
                    },
                  ]}>
                  <Input maxLength={2} edit={mode === 'edit'} />
                </Form.Item>
              </Col>
              <Col span='6' offset={1}>
                <Form.Item
                  label='Hotel Code'
                  name='hotelcode'
                  rules={[
                    {
                      type: 'string',
                      max: 16,
                      message:
                        'You have reached the max character length of 16',
                    },
                  ]}>
                  <Input maxLength={16} edit={mode === 'edit'} />
                </Form.Item>
              </Col>
              <Col span={6}>
                <FormItem name='bookable' label='Bookable'>
                  <Select allowClear showSearch>
                    {options.map((opt: string, index: number) => (
                      <Option value={opt} key={`bookable-${index}`}>
                        {opt}
                      </Option>
                    ))}
                  </Select>
                </FormItem>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span='6'>
                <Form.Item
                  label='Property Name (Short)'
                  name='shortname'
                  rules={[
                    {
                      type: 'string',
                      max: 32,
                      message:
                        'You have reached the max character length of 32',
                    },
                  ]}>
                  <Input maxLength={32} edit={mode === 'edit'} />
                </Form.Item>
              </Col>
              <Col span='6' offset={1}>
                <Form.Item
                  label='Property Name (Long)'
                  name='longname'
                  rules={[
                    {
                      type: 'string',
                      max: 64,
                      message:
                        'You have reached the max character length of 64',
                    },
                  ]}>
                  <Input maxLength={64} edit={mode === 'edit'} />
                </Form.Item>
              </Col>
            </Row>
          </div>
        </Form>
        <ActionButtonsBar
          onCancel={handleClickCancel}
          onSave={handleClickSave}
          disabledSave={disabledStatus}
          show={mode === 'edit'}
        />
      </Card>
    )
}

export default ODSForm
